export default "/corgi/pageapps/prepurchase/_next/static/media/gift.76b3fb4e.svg";